import { render } from "./NcrmWorkflowAutoSyncSettings.vue?vue&type=template&id=34d49d2e"
import script from "./NcrmWorkflowAutoSyncSettings.vue?vue&type=script&lang=js"
export * from "./NcrmWorkflowAutoSyncSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__